import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import { success, failed } from '../actions/UserListActions';
import { USER_LIST_LOAD } from '../constants/UserListConst';
import UserService from '../services/UserService';
import { USER_CREATE_LOAD } from '../constants/UserCreateConst';

export function* loaddata() {
  yield takeEvery(USER_LIST_LOAD, function* (payload) {
    try {
      const { page, filter } = payload;

      const res = yield call(UserService.getList, {
        page: page,
        filter: filter,
      });
      console.log('->>>>>>>>>>');
      yield put(success(res.data));
      console.log(res);
    } catch (err) {
      console.log('->>>>>>>>>> error');
      yield put(failed(err));
      console.log(err);
    }
  });
}

export default function* rootSaga() {
  yield all([fork(loaddata)]);
}
